import { useContext, useState } from "react";
import styles from "../Volume.module.css";
import { Button, Divider } from "@shopify/polaris";
import { VolumeBundleContext } from "../VolumeDiscount";
import DesignTabsWrapper from "../../../../components/DesignTabsWrapper/DesignTabsWrapper";
import type { CombinedBundleConfigInterface } from "../../Types";
import VolumeDesignGeneralCard from "./VolumeDesignGeneralCard";
import VolumeDesignProductCard from "./VolumeDesignProductCard";
import VolumeDesignFreeGift from "./VolumeDesignFreeGift";
import VolumeDesignUpsell from "./VolumeDesignUpsell";
import VolumeDesignFooterCard from "./VolumeDesignFooterCard";
import { useFormContext, useWatch } from "react-hook-form";

const VolumeDesignForm = () => {
    const context = useContext(VolumeBundleContext);
    const [activeDesignTab, setActiveDesignTab] = useState(0);
    const { control, getValues } = useFormContext();

    // Watch reactive values needed for conditional rendering
    const allOffers = useWatch({ control, name: "volume_discounts" }) ?? [];
    const defaultCta = useWatch({ control, name: "bundles_design.default_cta" });

    if (!context) return null;
    const { handleNext, inspectorTarget } = context;

    const showFreeGiftSettings = allOffers.filter((op: any) => op?.allow_free_gifts)?.length > 0;
    const showUpsellSettings = allOffers.filter((op: any) => op?.allow_upsell_products)?.length > 0;
    const showFooterKeys = !defaultCta;

    // Build a bundleConfig-like object for components that still need it
    const bundleConfig = getValues() as any as CombinedBundleConfigInterface;

    let nextTabIndex = 2;
    const freeGiftTabIndex = showFreeGiftSettings ? nextTabIndex++ : -1;
    const upsellTabIndex = showUpsellSettings ? nextTabIndex++ : -1;
    const footerTabIndex = showFooterKeys ? nextTabIndex++ : -1;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: 10 }}>
                <Divider borderColor="border" />
            </div>
            <DesignTabsWrapper
                bundleConfig={bundleConfig}
                activeDesignTab={activeDesignTab}
                setActiveDesignTab={setActiveDesignTab}
                showFreeGiftSettings={showFreeGiftSettings}
                showUpsellSettings={showUpsellSettings}
                hideFooterKeys={!showFooterKeys}
                validate={async () => []}
                submit={() => {}}
                inspectorTarget={inspectorTarget}
            >
                {activeDesignTab === 0 && <VolumeDesignGeneralCard />}

                {activeDesignTab === 1 && <VolumeDesignProductCard />}

                {activeDesignTab === freeGiftTabIndex && <VolumeDesignFreeGift />}

                {activeDesignTab === upsellTabIndex && <VolumeDesignUpsell />}

                {activeDesignTab === footerTabIndex && <VolumeDesignFooterCard />}
            </DesignTabsWrapper>

            {handleNext && (
                <>
                    <div className={styles.dividerStyle}>
                        <Divider borderColor="border" />
                    </div>
                    <div className={styles.bottomRowCta}>
                        <Button onClick={() => handleNext(0, "Content")}>Back</Button>
                        <Button onClick={() => handleNext(2, "Target")}>Next</Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default VolumeDesignForm;
